export default __webpack_public_path__ + "static/media/image1.846619e8.svg";